const LOGIN_METHODS = {
  email: 'email',
  phone_number: 'phone_number',
}

export { LOGIN_METHODS }
